<template>
  <div class="modules-tools__item">
    <div
      :class="['modules-tools__item-header', { single }]"
      @click="toggleModule(module)"
    >
      <div class="modules-tools__item-header__icon">
        <div class="modules-tools__item-header__icon-wrapper">
          <r-icon
            :name="getIconName(module.name.toLowerCase())"
            :size="36"
          ></r-icon>
        </div>
      </div>
      <div class="modules-tools__item-header__content">
        <r-title type="subtitle-1">
          {{ $t(`module-name:${module.name}`) }}
        </r-title>
        <r-text v-if="!single">{{
          `${getInstrumentsCount(module.id)} / ${instrumentsLength}`
        }}</r-text>
      </div>
      <div class="modules-tools__item-header__control">
        <el-switch class="r-switch" :value="isActive" />
      </div>
    </div>
    <div class="modules-tools__item-content" v-if="!single">
      <ul class="modules-tools__item__tools-list">
        <li
          :class="[
            'modules-tools__item__tools-item',
            { active: getInstrumentClass(module.id, e.id) }
          ]"
          v-for="e in module.instruments"
          :key="e.id"
          @click="toggleInstrument(module, e)"
        >
          <r-text>{{ $t(`instrument-name:${e.name}`) }}</r-text>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: { module: Object },
  data() {
    return {
      isActive: false
    };
  },
  watch: {
    userModules: {
      handler: function() {
        this.isModuleActive();
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    user() {
      return this.$store.state.userRoles.activeUser;
    },
    userModules() {
      return this.$store.state.userRoles.activeUserModules;
    },
    instrumentsLength() {
      return this.module.instruments.length;
    },
    single() {
      return !this.instrumentsLength;
    }
  },
  methods: {
    getIconName(moduleName) {
      let iconName;

      switch (moduleName) {
        case "map":
          iconName = "ksodd-map";
          break;
        case "book":
          iconName = "ksodd-tables";
          break;
        case "chart":
          iconName = "ksodd-graphs";
          break;
        case "datasourcemanager":
          iconName = "box";
          break;
        case "userroles":
          iconName = "user-group";
          break;
        case "traffic counts":
          iconName = "camera";
          break;
        case "pt registry":
          iconName = "bus";
          break;
        case "situation center":
          iconName = "s-center";
          break;
        case "scenario modelling":
          iconName = "modelling";
          break;
        default:
          iconName = moduleName;
          break;
      }

      return iconName;
    },
    isModuleActive() {
      const module = this.userModules.find(item => item.id === this.module.id);

      this.isActive = !!(module && module._action !== "deleted");
    },
    getModuleStatusClass(id) {
      const module = this.userModules.find(item => item.id === id);
      if (module && module._action !== "deleted") return true;
      return false;
    },
    getInstrumentsCount(id) {
      const module = this.userModules.find(item => item.id === id);
      const instruments =
        module && module.instruments ? module.instruments : [];
      const counted = instruments.filter(item => item._action !== "deleted");
      return counted.length;
    },
    getInstrumentClass(moduleId, id) {
      const module = this.userModules.find(item => item.id === moduleId);
      const instruments =
        module && module.instruments ? module.instruments : [];
      const instrument = instruments.find(item => item.id === id);
      if (instrument && instrument._action !== "deleted") return true;
      return false;
    },
    toggleInstrument(currentModule, instrument) {
      const modules = this.userModules;
      const module = modules.find(item => item.id === currentModule.id);
      let instruments;

      if (module && module._action === "deleted") {
        instruments = module && module.instruments ? module.instruments : [];
        const founded = instruments.find(item => item.id === instrument.id);
        if (founded) {
          founded._action = undefined;
        } else {
          instruments.push({ ...instrument, _action: "created" });
        }
        module._action = undefined;
      } else if (module) {
        instruments = module && module.instruments ? module.instruments : [];
        const founded = instruments.find(item => item.id === instrument.id);
        let index;
        if (founded) {
          switch (founded._action) {
            case "deleted":
              founded._action = undefined;
              break;
            case "created":
              index = instruments.findIndex(item => item.id === founded.id);
              instruments.splice(index, 1);
              break;
            default:
              founded._action = "deleted";
              instruments.push({ changed: true });
              instruments.splice(instruments.length - 1, 1);
              break;
          }
        } else {
          instruments.push({ ...instrument, _action: "created" });
        }
      } else {
        modules.push({ ...currentModule, _action: "created", instruments: [] });
        modules[modules.length - 1].instruments.push({
          ...instrument,
          _action: "created"
        });
      }

      this.$forceUpdate();
    },
    toggleModule(current) {
      const modules = this.userModules;
      const module = modules.find(item => item.id === current.id);
      let index;

      if (module) {
        switch (module._action) {
          case "deleted":
            module._action = undefined;
            module.instruments = current.instruments.map(item => ({
              ...item,
              _action: "created"
            }));
            break;
          case "created":
            index = modules.findIndex(item => item.id === module.id);
            modules.splice(index, 1);
            break;
          default:
            module._action = "deleted";
            module.instruments = module.instruments.map(item => ({
              ...item,
              _action: "deleted"
            }));
        }
      } else {
        modules.push({
          ...current,
          _action: "created",
          instruments: current.instruments.map(item => ({
            ...item,
            _action: "created"
          }))
        });
      }

      this.$forceUpdate();
    }
  }
};
</script>

<style lang="scss">
.modules-tools__item {
  width: 270px;
  border-radius: var(--border-radius);
  border: 1px solid;
  position: relative;
  overflow: hidden;
  border-color: var(--dividers_low_contrast) !important;
  &-header {
    max-height: 44px;
    height: 44px;
    padding: 12px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid;
    overflow: hidden;
    cursor: pointer;
    border-color: var(--dividers_low_contrast) !important;
    &.single {
      border-bottom: none;
    }
    &__icon {
      width: 44px;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    &__content {
      box-sizing: border-box;
      padding: 0 12px;
      height: 100%;
      width: 168px;
      display: flex;
      align-items: flex-start;
      justify-content: center;
      flex-direction: column;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      .r-main-title {
        width: 100%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
    &__control {
      height: 100%;
      width: 32px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  &__tools {
    &-list {
      width: 100%;
      padding: 4px;
      box-sizing: border-box;
    }
    &-item {
      position: relative;
      border-radius: var(--border-radius);
      width: 100%;
      padding: 6px 32px;
      box-sizing: border-box;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      margin-bottom: 2px;
      cursor: pointer;
      &:last-child {
        margin-bottom: 0;
      }
      &.active {
        background-color: var(--accent_selected) !important;
        color: var(--accent_primary);
        &:before {
          content: "";
          display: block;
          position: absolute;
          height: 4px;
          width: 8px;
          border-bottom: 1px solid;
          border-left: 1px solid;
          border-color: var(--accent_primary);
          transform: rotate(-45deg) translateY(-50%);
          left: 12px;
          top: 45%;
        }
      }
      &:hover,
      &:active {
        background-color: var(--accent_selected) !important;
      }
    }
  }
}
</style>

<i18n>
{
  "ru": {
    "module-name:Map": "Карта",
    "module-name:Book": "Справочник",
    "module-name:Chart": "Графики",
    "module-name:Traffic Counts": "Замеры",
    "module-name:Modelling": "Моделирование",
    "module-name:DataSourceManager": "Менеджер ИД",
    "module-name:PT Registry": "Реестр ОТ",
    "module-name:UserRoles": "Роли и разрешения",
    "module-name:Situation Center": "Ситуационный центр",
    "module-name:Scenario Modelling": "Расчёты и сценарии",

    "instrument-name:Styles": "Стилизация",
    "instrument-name:Filters": "Фильтры",
    "instrument-name:Time Machine": "Машина времени",
    "instrument-name:Heatmaps": "Тепловая карта",
    "instrument-name:Diagrams": "Диаграммы",
    "instrument-name:Editor": "Редактирование",
    "instrument-name:Columns Settings": "Настройка отображения столбцов",
    "instrument-name:Fill": "Заливка",
    "instrument-name:Settings": "Настройки"
  },
  "en": {
    "module-name:Map": "Map",
    "module-name:Book": "Book",
    "module-name:Chart": "Charts",
    "module-name:Traffic Counts": "Traffic Counts",
    "module-name:Modelling": "Modelling",
    "module-name:DataSourceManager": "Datasource Manager",
    "module-name:PT Registry": "PT Registry",
    "module-name:UserRoles": "User&Roles",
    "module-name:Situation Center": "Situation center",
    "module-name:Scenario Modelling": "Calculations and scenarios",

    "instrument-name:Styles": "Styles",
    "instrument-name:Filters": "Filters",
    "instrument-name:Time Machine": "Time machine",
    "instrument-name:Heatmaps": "Heatmaps",
    "instrument-name:Diagrams": "Diagrams",
    "instrument-name:Editor": "Editor",
    "instrument-name:Columns Settings": "Columns settings",
    "instrument-name:Fill": "Fill",
    "instrument-name:Settings": "Settings"
  }
}
</i18n>
